import React from "react";

export default class ProfileImage extends React.Component {
  render() {
    return (
      <img
        src={"https://i.postimg.cc/JhVp19Z5/IMG-8718.jpg"}
        alt="Avatar"
        className="profileImage"
      />
    );
  }
}
